const getDistrictCodeLength = (pattern: string): number | undefined => {
  // Get length from full postcode
  if (pattern.length > 4) {
    return {
      AA9A9AA: 3,
      A9A9AA: 2,
      A99AA: 2,
      A999AA: 3,
      AA99AA: 3,
      AA999AA: 4,
    }[pattern];
  }
  // Get length from outward code
  else {
    return {
      AA9A: 3,
      A9A: 2,
      A9: 2,
      A99: 3,
      AA9: 3,
      AA99: 4,
    }[pattern];
  }
};

export const getDistrictCode = (postcode: string): string | undefined => {
  // Source: https://ideal-postcodes.co.uk/guides/uk-postcode-format
  const noSpacedPostcode = postcode.replace(/\s/g, "");
  const pattern = noSpacedPostcode.replace(/\d/g, "9").replace(/[^9]/g, "A");
  const dcLength = getDistrictCodeLength(pattern);

  if (!dcLength) {
    return;
  }

  return noSpacedPostcode.slice(0, dcLength).toUpperCase();
};
